import axios from "axios";

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
export const getRandomBool = () => {
  return Math.random() >= 0.5;
};
//
export const toHex = (num) => {
  const val = Number(num);
  return "0x" + val.toString(16);
};

export const shortenAddress = (address) => {
  if (!address) return "";
  return `${address.slice(0, 5)}...${address.slice(address.length - 4)}`;
};
export const shortenAddressLong = (address) => {
  if (!address) return "";
  return `${address.slice(0, 10)}...${address.slice(address.length - 9)}`;
};
export const formatDateToLocalString = (date) => {
  return new Date(date).toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
export const PINATA_GATEWAY =
  process.env.REACT_APP_PINATA_GATEWAY || "https://gateway.pinata.cloud/ipfs/";

export const uploadToPinata = async (file) => {
  const blob = file instanceof Blob ? file : new Blob([file]);
  const filename =
    (file && typeof file === "object" && file.name) || "document";
  const formData = new FormData();
  formData.append("file", blob, filename);
  const response = await axios.post(
    "https://api.pinata.cloud/pinning/pinFileToIPFS",
    formData,
    {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
      },
    },
  );
  return response.data;
};
